import apiClient from './api';
import { User, ApiResponse } from '../types';

export const authService = {
  // Register a new user
  register: async (userData: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
  }): Promise<ApiResponse<{ token: string; user: User }>> => {
    const response = await apiClient.post('/auth/register', userData);

    return response.data;
  },

  // Login user
  login: async (credentials: {
    email: string;
    password: string;
  }): Promise<ApiResponse<{ token: string; user: User }>> => {
    const response = await apiClient.post('/auth/login', credentials);

    return response.data;
  },

  // Social login
  socialLogin: async (provider: string, token: string): Promise<ApiResponse<{ token: string; user: User }>> => {
    const response = await apiClient.post('/auth/social', { provider, token });

    return response.data;
  },

  // Logout (client-side)
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  // Get current user from localStorage
  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');

    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is authenticated
  isAuthenticated: (): boolean => {
    const token = localStorage.getItem('token');

    return !!token;
  },

  // Store user data
  storeUserData: (token: string, user: User) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },

  // Verify email
  verifyEmail: async (token: string): Promise<ApiResponse<{ user: User }>> => {
    const response = await apiClient.post('/auth/verify-email', { token });

    return response.data;
  },
};
